function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { SvgIcon } from '@mui/material';
const Arrow = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 9 20",
    sx: {
      width: 9,
      height: 20
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.85578C9 7 3 5.45652 9.53674e-07 0.5L5.4472e-07 9.85578L1.23158e-07 19.5C3 14.5435 9 12.5 9 9.85578Z",
    fill: "currentColor"
  }));
};
export default Arrow;